import React from 'react';

const Footer = () => (
  <footer className="readmin-footer" >
    <p>Copyright © Estrategas de México 2018</p>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js